import JourneySelector from './JourneySelector';

import { JourneySelectorProps } from './JourneySelector.types';

export type { JourneySelectorProps };
export default JourneySelector;
